module.exports = __webpack_public_path__ + "img/document.a21d95c3.svg";